export default __webpack_public_path__ + "static/media/29.b8b4c580.png";